import { Helmet } from 'react-helmet-async';

export const withHelmet = (element, { title }) => (
  <>
    <Helmet>{title && <title>Portal | {title}</title>}</Helmet>
    {element}
  </>
);
